module.exports = __webpack_public_path__ + "static/img/2005.faf9c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2005.jpg
// module id = 296
// module chunks = 0